// extracted by css-extract-rspack-plugin
export default {"text":"kkkWOJvBfaIC9DCO","small":"B5w4qlhUg3sL3sY8","medium":"rRvSm4FijoHqzN5G","large":"D_VvATKIbZoK5R4V","bold":"Z33NpIXy9OwaLUqP","truncate":"L90sIrSiZkXVL6kP"};